import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);
  }

  _createClass(Auth, null, [{
    key: "authenticateUser",
    value: function authenticateUser(token, user) {
      localStorage.setItem('token', token);
      Auth.setUser(user);
    }
  }, {
    key: "isLocalStorageSupported",
    value: function isLocalStorageSupported() {
      try {
        var key = "__some_random_key_to_know_you_use_local_storage__";
        localStorage.setItem(key, key);
        localStorage.removeItem(key);
        return true;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "isUserAuthenticated",
    value: function isUserAuthenticated() {
      return Auth.getToken() !== null && Auth.getUser() !== null;
    }
  }, {
    key: "isAccountConfirmed",
    value: function isAccountConfirmed() {
      var _ref = Auth.getUser() || {},
          _ref$registration = _ref.registration;

      _ref$registration = _ref$registration === void 0 ? {} : _ref$registration;
      var _ref$registration$con = _ref$registration.confirmed,
          confirmed = _ref$registration$con === void 0 ? false : _ref$registration$con;
      return !!confirmed;
    }
  }, {
    key: "deauthenticateUser",
    value: function deauthenticateUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return localStorage.getItem('token');
    }
  }, {
    key: "getUser",
    value: function getUser() {
      try {
        return JSON.parse(localStorage.getItem('user'));
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }, {
    key: "getAuthorizationHeader",
    value: function getAuthorizationHeader() {
      return "bearer ".concat(Auth.getToken());
    }
  }]);

  return Auth;
}();

export default Auth;